export default __webpack_public_path__ + "static/media/31.0b7fb50e.jpg";